import { Skeleton } from '@mui/material'

const getWalletIconSrc = (icon: string): string => {
  const trimmedIcon = icon.trim()

  if (
    trimmedIcon.startsWith('data:') ||
    trimmedIcon.startsWith('http://') ||
    trimmedIcon.startsWith('https://') ||
    trimmedIcon.startsWith('blob:') ||
    trimmedIcon.startsWith('chrome-extension://') ||
    trimmedIcon.startsWith('/')
  ) {
    return trimmedIcon
  }

  if (trimmedIcon.startsWith('<svg')) {
    return `data:image/svg+xml;utf8,${encodeURIComponent(trimmedIcon)}`
  }

  return trimmedIcon
}

const WalletIcon = ({
  provider,
  width = 30,
  height = 30,
  icon,
}: {
  provider: string
  width?: number
  height?: number
  icon?: string
}) => {
  return icon ? (
    <img width={width} height={height} src={getWalletIconSrc(icon)} alt={`${provider} logo`} />
  ) : (
    <Skeleton variant="circular" width={width} height={height} />
  )
}

export default WalletIcon
